<template>
  <a-statistic-countdown :class="[bem.b()]" v-bind="attrs">
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-statistic-countdown>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlStatisticCountdown' })

// const props = defineProps(statisticProps)
const bem = createNamespace('statistic-countdown')

const attrs = useAttrs()
</script>
